import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle, CircleNotch, XCircle } from "@phosphor-icons/react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let stopped = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (stopped) return;
        setStatus(data);
        if (data.payment_status === "paid" || data.payment_status === "failed" || data.payment_status === "expired") return;
        if (tries < 15) {
          setTimeout(() => setTries((t) => t + 1), 2000);
        }
      } catch (e) {
        setStatus({ payment_status: "error" });
      }
    };
    poll();
    return () => { stopped = true; };
    // eslint-disable-next-line
  }, [sessionId, tries]);

  const paid = status.payment_status === "paid";
  const failed = ["failed", "expired", "error"].includes(status.payment_status);

  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center">
      <div className="samaaj-card p-10" data-testid="payment-result">
        {paid ? (
          <>
            <CheckCircle size={48} weight="fill" className="mx-auto text-[#2C4A3B]" />
            <h1 className="font-heading text-4xl mt-4">Payment successful!</h1>
            <p className="text-[#5C564D] mt-2">Your purchase of <span className="font-semibold text-[#1C1B1A]">{status.listing_title}</span> is confirmed.</p>
          </>
        ) : failed ? (
          <>
            <XCircle size={48} weight="fill" className="mx-auto text-red-700" />
            <h1 className="font-heading text-4xl mt-4">Payment did not complete</h1>
            <p className="text-[#5C564D] mt-2">Please try again or contact the seller.</p>
          </>
        ) : (
          <>
            <CircleNotch size={48} className="mx-auto text-[#D95A41] animate-spin" />
            <h1 className="font-heading text-4xl mt-4">Confirming your payment…</h1>
            <p className="text-[#5C564D] mt-2">Hang tight, this takes just a moment.</p>
          </>
        )}
        <Link to="/marketplace" data-testid="back-marketplace" className="samaaj-btn-outline mt-6 inline-block">Back to Marketplace</Link>
      </div>
    </div>
  );
}
